import axios from "axios";
import store from "./store";
const HTTP = axios.create({
  baseURL: process.env.API + "/api/",
  withCredentials: true,
  headers: {
    "Content-Type": "application/json",
    "Access-Control-Allow-Origin": "http://localhost:8080",
    "Access-Control-Allow-Methods": "GET, PUT, POST, DELETE, OPTIONS",
    xsrfCookieName: "XSRF-TOKEN", // default
    // // `xsrfHeaderName` is the name of the http header that carries the xsrf token value
    xsrfHeaderName: "X-XSRF-TOKEN", // default
  },
});

HTTP.interceptors.request.use(
  (config) => {
    const token = store.getters["auth/token"];
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

export { HTTP };

// HTTP.interceptors.response.use(
//   response => {
//     // intercept the global error
//     return response;
//   },
//   function(error) {
//     let originalRequest = error.config;
//     if (error.response.status === 401 && !originalRequest._retry) {
//       // if the error is 401 and hasent already been retried
//       originalRequest._retry = true; // now it can be retried
//       return HTTP.post("/users/token", null)
//         .then(data => {
//           // store.dispatch("authfalse");
//           // store.dispatch("authtruth", data.data);
//           // originalRequest.headers["Authorization"] =
//           //   "Bearer " + store.state.token; // new header new token
//           return HTTP(originalRequest); // retry the request that errored out
//         })
//         .catch(error => {
//           this.$router.push("/login");
//         });
//     }
//     if (error.response.status === 404 && !originalRequest._retry) {
//       originalRequest._retry = true;
//       window.location.href = "/";
//       return;
//     }
//     // Do something with response error
//     return Promise.reject(error);
//   }
// );
